import * as types from './types';

export default {
  [types.GET_JOBS](state, jobs) {
    state.jobs = jobs;
  },
  [types.CACHE_JOBS](state, { key, jobs }) {
    state.cachedJobs[key] = jobs;
  },
  [types.SET_JOBS](state, jobs) {
    state.jobs = jobs;
  },
  [types.SET_JOBS_LOADING](state, jobsLoading) {
    state.jobsLoading = jobsLoading;
  },
  [types.SET_JOB_LOADING](state, jobLoading) {
    state.jobLoading = jobLoading;
  },
  [types.SET_CATEGORIES](state, categories) {
    state.categories = categories;
  },
  [types.CACHE_CATEGORIES](state, { key, categories }) {
    state.cachedCategories[key] = categories;
  },
  [types.CACHE_JOBID](state, { key, data }) {
    state.cachedJobId[key] = data;
  },
  [types.SET_JOBID](state, job) {
    state.job = job;
  },
  [types.SET_JOB_COMPANY_ID](state, jobs) {
    state.jobsByCompanyId = jobs;
  },
  [types.CACHE_JOB_COMPANY_ID](state, { key, data }) {
    state.cachedJobCompanyId[key] = data;
  },
  [types.JOBS_FILTERS](state, data) {
    state.jobsFilters = data;
  },
};
